import type { FC } from 'react';
import { useCallback } from 'react';
import type { ActionProps } from '../../types';
import { observer } from 'mobx-react-lite';
import useRulePageMode from '../../hooks/useRulePageMode';
import useCurrentTasksFormStore from '../../hooks/useCurrentTasksFormStore';
import type { OptionValue } from '../../../../types/shared';
import { useConditionsConstants } from '../../api';
import { RuleEditAutoCompleteStyled } from '../RuleEditTasksFormComponents';

export const SubActionMetrics: FC<Pick<ActionProps, 'indexAction' | 'indexTask' | 'indexVariant'>> = observer(
  ({ indexAction, indexVariant, indexTask }) => {
    const isVariant = typeof indexVariant === 'number';
    const { isRead } = useRulePageMode();
    const tasksFormStore = useCurrentTasksFormStore();
    const handleChangeMetric = useCallback(
      (value: OptionValue) => {
        tasksFormStore.setSubActionField({
          indexTask,
          indexAction,
          indexVariant,
          field: 'value',
          value: value as string,
        });
      },
      [tasksFormStore, indexTask, indexAction, indexVariant]
    );

    const { data: metrics } = useConditionsConstants({
      config: { select: (data) => data.map(({ name, id }) => ({ value: id, label: name })) },
    });

    const storedValue = tasksFormStore.getSubActionValues({ indexTask, indexAction, indexVariant }).value;

    return (
      <RuleEditAutoCompleteStyled
        allSelectable={false}
        value={storedValue}
        onChange={handleChangeMetric}
        id={`AutocompleteActionMetrics:${indexTask}.${indexAction}.SubAction:Value`}
        options={metrics ?? []}
        InputProps={{
          ...(tasksFormStore?.propsRestriction ?? null),
          disabled: isRead || isVariant,
        }}
      />
    );
  }
);

export default SubActionMetrics;
